import moment from 'moment';

export const skipMonthForEachInstallment = (date, part) => moment(date).add(part, 'M').toDate();
